/*
 * @Author: shiao
 * @Date: 2020-12-05 15:39:16
 * @LastEditTime: 2021-01-29 16:37:27
 * @LastEditors: shiao
 * @Description: 公用方法
 * @FilePath: \o2o-appd:\gongsi\h5-hotel\h5\src\pages\hotel\api\function.js
 */
const commonfunction = {
    unitConvert(num) {
        var moneyUnits = ["m", "km"]
        var dividend = 1000;
        var curentNum = num;
        //转换数字 
        var curentUnit = moneyUnits[0];
        //转换单位 
        if ([undefined, '', null, 'undefined'].includes(curentNum)) {
            return '0m'
        }
        for (var i = 0; i < 2; i++) {
            curentUnit = moneyUnits[i]
            if (i == 1) { break }
            if (commonfunction.strNumSize(curentNum) < 4) {
                break;
            }
            curentNum = curentNum / dividend
        }
        let m = Number(curentNum).toFixed(2) + curentUnit
        return m;
    },
    strNumSize(tempNum) {
        var stringNum = tempNum.toString()
        var index = stringNum.indexOf(".")
        var newNum = stringNum;
        if (index != -1) {
            newNum = stringNum.substring(0, index)
        }
        return newNum.length
    },
    municipality(address) {
        let pname = (address.adcode).slice(0, 2);
        let obj
        switch (pname) {
            case '50'://重庆
                obj = {
                    province: {
                        name: address.province,
                        code: Number((address.adcode).slice(0, 2)) * 10000
                    },
                    city: {
                        name: '重庆市',
                        code: 500100
                    }
                }
                break;
            case '31'://上海
                obj = {
                    province: {
                        name: address.province,
                        code: Number((address.adcode).slice(0, 2)) * 10000
                    },
                    city: {
                        name: '上海市',
                        code: 310100
                    }
                }
                break;
            case '11'://北京
                obj = {
                    province: {
                        name: address.province,
                        code: Number((address.adcode).slice(0, 2)) * 10000
                    },
                    city: {
                        name: '北京市',
                        code: 110100
                    }
                }
                break;
            case '12'://天津
                obj = {
                    province: {
                        name: address.province,
                        code: Number((address.adcode).slice(0, 2)) * 10000
                    },
                    city: {
                        name: '天津市',
                        code: 120100
                    }
                }
                break;
            case '82': ;//澳门
            case '81'://香港
                obj = {
                    province: {
                        name: address.province,
                        code: Number((address.adcode).slice(0, 2)) * 10000
                    },
                    city: {
                        name: address.district,
                        code: Number(address.adcode)
                    }
                }
                break;
            case '71'://台湾
                obj = {
                    province: {
                        name: address.province,
                        code: Number((address.adcode).slice(0, 2)) * 10000
                    },
                    city: {
                        name: "新北市",
                        code: 71001
                    }
                }
                break;
            default:
                obj = {
                    province: {
                        name: address.province,
                        code: Number((address.adcode).slice(0, 2)) * 10000
                    },
                    city: {
                        name: address.district,
                        code: Number((address.adcode).slice(0, 4)) * 100
                    }
                };
        };
        return obj
    }
}
export default commonfunction